import Title1 from './Title1';
import Title3 from './Title3';
import Title4 from './Title4';
import Title5 from './Title5';
import Title6 from './Title6';
import Title9 from './Title9';
import Title11 from './Title11';
import Title20 from './Title20';
import Title23 from './Title23';
import Title24 from './Title24';
import Title26 from './Title26';
import Title28 from './Title28';
import Title29 from './Title29';
import Title30 from './Title30';
import Title32 from './Title32';
import Title35 from './Title35';
import Title37 from './Title37';
import Title38 from './Title38';
import Title39 from './Title39';
import Title46 from './Title46';
import Title47 from './Title47';


export {
  Title1,
  Title3,
  Title4,
  Title5,
  Title6,
  Title9,
  Title11,
  Title20,
  Title23,
  Title24,
  Title26,
  Title28,
  Title29,
  Title30,
  Title32,
  Title35,
  Title37,
  Title38,
  Title39,
  Title46,
  Title47,
}



// WEBPACK FOOTER //
// src/routes/visualChart/components/Titles/index.js